import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { sendVoucherEmail } from "../api";
import { errMsg, fmtMoney, fmtDate, fmtDateTime, RES_STATUS } from "../utils";

/** Voucher imprimible del cupón (window.print + CSS @media print). */
export default function Voucher({ reservation, me, onBack, onToast }) {
  const r = reservation;
  const [mail, setMail] = useState(r?.contact_email || "");
  const [sending, setSending] = useState(false);
  if (!r) return null;

  async function enviarCorreo() {
    const dest = mail.trim();
    if (dest && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(dest)) {
      onToast("El correo no es válido. Ejemplo: nombre@empresa.com");
      return;
    }
    setSending(true);
    try {
      const res = await sendVoucherEmail(r.reservation_code, dest || null);
      onToast(`Voucher enviado a ${res.sent_to}`);
    } catch (e) {
      onToast(errMsg(e, "No se pudo enviar el correo."));
    } finally {
      setSending(false);
    }
  }

  const st = RES_STATUS[r.status] || { label: r.status, cls: "" };
  const company = me?.contract_name || me?.company_name || "";

  async function copyCode() {
    const code = r.reservation_code || "";
    try {
      await navigator.clipboard.writeText(code);
      onToast("Código copiado.");
    } catch {
      // Fallback para navegadores sin clipboard API (contextos no seguros).
      const ta = document.createElement("textarea");
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        onToast("Código copiado.");
      } catch {
        onToast("No se pudo copiar. Anota el código.");
      }
      document.body.removeChild(ta);
    }
  }

  return (
    <>
      <div className="voucher">
        <div className="v-brand">ALAS · Cupón de reserva</div>
        {company && <div className="v-company">{company}</div>}
        {me?.company_nit && <div className="v-nit">NIT {me.company_nit}</div>}

        {r.status && r.status !== "active" && (
          <div style={{ marginTop: 10 }}>
            <span className={`chip ${st.cls}`}>{st.label}</span>
          </div>
        )}

        <div className="v-code">{r.reservation_code}</div>

        <div className="v-qr">
          <QRCodeSVG value={String(r.reservation_code || "")} size={168} marginSize={2} />
        </div>

        <div className="v-band">
          SUJETO A DISPONIBILIDAD — NO GARANTIZA SILLA NI HORARIO
        </div>

        <div className="v-rows">
          <div className="v-row">
            <span>Ruta</span>
            <b>{r.origin_name} → {r.destination_name}</b>
          </div>
          <div className="v-row">
            <span>Fecha del viaje</span>
            <b>{fmtDate(r.travel_date)}</b>
          </div>
          <div className="v-row">
            <span>Pasajeros</span>
            <b>{r.passenger_count}</b>
          </div>
          <div className="v-row">
            <span>Valor</span>
            <b>{fmtMoney(r.committed_amount)}</b>
          </div>
          <div className="v-row">
            <span>Vence</span>
            <b>{fmtDateTime(r.valid_until)}</b>
          </div>
        </div>

        <div className="v-pax">
          {(r.passengers || []).map((p, i) => (
            <div className="v-p" key={i}>
              <span className="v-p-doc">{p.doc_type} {p.doc_number}</span>
              <span className="v-p-name">{p.first_name} {p.last_name}</span>
            </div>
          ))}
        </div>

        <div className="v-foot">
          Presenta este código en taquilla para redimir tu reserva.
        </div>
      </div>

      <div className="no-print">
        <div className="card" style={{ marginTop: 16 }}>
          <label style={{ marginTop: 0 }}>Enviar el voucher por correo</label>
          <input
            type="email"
            inputMode="email"
            autoCapitalize="none"
            value={mail}
            onChange={(e) => setMail(e.target.value)}
            placeholder="nombre@correo.com"
          />
          <button
            className="btn accent"
            style={{ marginTop: 12 }}
            onClick={enviarCorreo}
            disabled={sending || !mail.trim()}
          >
            {sending ? "Enviando…" : "Enviar por correo"}
          </button>
          {r.contact_email && (
            <div className="tot-note" style={{ marginTop: 8 }}>
              Ya se envió a <b>{r.contact_email}</b>. Puedes reenviarlo o cambiar el correo.
            </div>
          )}
        </div>

        <button className="btn" style={{ marginTop: 16 }} onClick={() => window.print()}>
          🖨 Imprimir
        </button>
        <button className="btn ghost" style={{ marginTop: 10 }} onClick={copyCode}>
          Copiar código
        </button>
        <button className="btn ghost" style={{ marginTop: 10 }} onClick={onBack}>
          Volver
        </button>
      </div>
    </>
  );
}
